import { SAMPLE_WINNERS } from "@/shared/content.js";
import { uz } from "@/shared/i18n/uz.js";
import { Container, SampleNotice, SectionTitle } from "@/shared/ui/index.js";
import { usePageMeta } from "@/app/meta.js";

export function WinnersPage() {
  usePageMeta(uz.winners.title, uz.winners.lead);

  // Mavsumlar bo'yicha guruhlanadi — jadval bittada bir necha mavsumni
  // ko'rsatganda o'rin raqami qaysi mavsumniki ekani aniq bo'lsin.
  const seasons = [...new Set(SAMPLE_WINNERS.map((winner) => winner.season))];

  return (
    <Container className="py-12">
      <SectionTitle title={uz.winners.title} lead={uz.winners.lead} />
      <SampleNotice text={uz.sample.notice} />

      {SAMPLE_WINNERS.length === 0 ? (
        <p className="text-ink-2 py-10 text-center">{uz.winners.empty}</p>
      ) : (
        <div className="flex flex-col gap-10">
          {seasons.map((season) => (
            <section key={season}>
              <h2 className="font-cond text-ink-2 mb-3 text-xl font-semibold tracking-wide">
                {season}
              </h2>

              <div className="border-line bg-card overflow-x-auto rounded-xl border">
                <table className="tabular w-full min-w-[40rem] border-collapse text-sm">
                  <thead>
                    <tr className="border-line border-b">
                      <Th>{uz.winners.columns.place}</Th>
                      <Th align="left">{uz.winners.columns.team}</Th>
                      <Th align="left">{uz.winners.columns.district}</Th>
                      <Th align="left">{uz.winners.columns.captain}</Th>
                      <Th>{uz.winners.columns.played}</Th>
                      <Th>{uz.winners.columns.won}</Th>
                      <Th>{uz.winners.columns.rating}</Th>
                    </tr>
                  </thead>
                  <tbody>
                    {SAMPLE_WINNERS.filter((winner) => winner.season === season).map(
                      (winner, index) => (
                        <tr key={winner.id} className="border-line border-b last:border-b-0">
                          <Td>
                            <span
                              className={`font-cond text-lg font-bold ${
                                index === 0 ? "text-gold" : "text-ink-3"
                              }`}
                            >
                              {index + 1}
                            </span>
                          </Td>
                          <Td align="left" className="font-medium">
                            {winner.team}
                          </Td>
                          <Td align="left" className="text-ink-2">
                            {winner.district}
                          </Td>
                          <Td align="left" className="text-ink-2">
                            {winner.captain}
                          </Td>
                          <Td className="text-ink-2">{winner.played}</Td>
                          <Td className="font-medium">{winner.won}</Td>
                          <Td className="font-semibold">{winner.rating}</Td>
                        </tr>
                      ),
                    )}
                  </tbody>
                </table>
              </div>
            </section>
          ))}
        </div>
      )}
    </Container>
  );
}

function Th({ align = "right", children }: { align?: "left" | "right"; children: string }) {
  return (
    <th
      className={`font-cond text-ink-3 px-4 py-2.5 text-xs font-semibold tracking-wider whitespace-nowrap ${
        align === "left" ? "text-left" : "text-right"
      }`}
    >
      {children}
    </th>
  );
}

function Td({
  align = "right",
  className = "",
  children,
}: {
  align?: "left" | "right";
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <td
      className={`px-4 py-3 ${align === "left" ? "text-left" : "text-right"} ${className}`}
    >
      {children}
    </td>
  );
}
